/* eslint-disable no-inner-declarations */
import dashboardApi from 'services/api/dashboard'
import hotelApi from 'services/api/hotel'

import {
  DELETE_EXCLUSION_FAILED,
  DELETE_EXCLUSION_STARTED,
  DELETE_EXCLUSION_SUCCESS,
  UPDATE_ACTIVE_SERVICES,
  UPDATE_CURRENT_HOTEL,
  UPDATE_HOTEL_DATA,
  UPDATE_SERVICE_FAILED,
  UPDATE_SERVICE_STARTED,
  UPDATE_SERVICE_SUCCESS
} from './actionTypes'

export const deleteExclusion = id => {
  return async dispatch => {
    dispatch({
      type: DELETE_EXCLUSION_STARTED,
      payload: id
    })

    try {
      const res = await dashboardApi.removeExclusion(id)
      dispatch({
        type: DELETE_EXCLUSION_SUCCESS,
        payload: res
      })
    } catch {
      dispatch({
        type: DELETE_EXCLUSION_FAILED,
        payload: id
      })
    }
  }
}

export const updateService = ({
  action,
  plan,
  planRate,
  isFlatMonthly,
  hotelId,
  effectiveFrom
}) => {
  return async dispatch => {
    dispatch({
      type: UPDATE_SERVICE_STARTED
    })

    try {
      const response = await dashboardApi.modifyService(
        {
          action,
          plan,
          planRate,
          isFlatMonthly,
          effectiveFrom
        },
        hotelId
      )
      dispatch({
        type: UPDATE_SERVICE_SUCCESS,
        payload: response
      })

      dispatch(getOtherHotelDetails(hotelId))
    } catch (err) {
      dispatch({
        type: UPDATE_SERVICE_FAILED,
        payload: err
      })
    }
  }
}

export const updateCurrentHotel = data => ({
  type: UPDATE_CURRENT_HOTEL,
  payload: data
})

export const updateHotelData = (id, data) => ({
  type: UPDATE_HOTEL_DATA,
  payload: { id, data }
})

export const getOtherHotelDetails = id => {
  return async dispatch => {
    dispatch({
      type: 'GET_OTHER_HOTEL_DETAILS_STARTED'
    })

    try {
      const {
        subsidiary,
        trackingInfoUsages,
        locationExclusions,
        chainExclusions,
        ...rest
      } = await hotelApi.getDetails(id)

      const getCat = (arr, cat) => arr.filter(e => e.category === cat)

      const excludedFullTrackingCodes = [
        ...getCat(locationExclusions, 'TrackingInfoFull'),
        ...getCat(chainExclusions, 'TrackingInfoFull')
      ]
      const excludedPartialTrackingCodes = [
        ...getCat(locationExclusions, 'TrackingInfoStartingWith'),
        ...getCat(chainExclusions, 'TrackingInfoStartingWith')
      ]

      function getTrackingCodeExclusions(val) {
        if (excludedFullTrackingCodes.includes(val)) {
          return 'Full tracking code'
        }

        if (excludedPartialTrackingCodes.some(c => c.category.startsWith(val))) {
          return 'Partial tracking code'
        }

        return null
      }

      const trackingCodeWexclusons = trackingInfoUsages.map(r => ({
        ...r,
        exclusion: getTrackingCodeExclusions(r.trackableCode)
      }))

      dispatch({
        type: 'GOT_OTHER_HOTEL_DETAILS',
        payload: {
          id,
          details: {
            ...subsidiary,
            chainExclusions,
            locationExclusions,
            trackingInfoUsages: trackingCodeWexclusons,
            ...rest
          }
        }
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: 'GET_OTHER_HOTEL_DETAILS_FAILED',
        payload: err
      })
    }
  }
}

export const updateActiveServices = activeServices => ({
  type: UPDATE_ACTIVE_SERVICES,
  payload: activeServices
})
